function abortableFetch(input, init) {
  var controller = new AbortController();
  var signal = controller.signal;

  if (init) {
    init.signal = signal;
  }
  else {
    init = {
      signal: signal
    }
  }

  var abortablePromise = fetch(input, init);
  abortablePromise.abort = function () {
    controller.abort();
  }

  return abortablePromise;
}
